import React, { useEffect, useState } from 'react';
import { useAuth } from '@/components/Auth/AuthProvider';
import apiClient from '@/services/api';
import { companyLogoUrl } from './companyView';

/**
 * The signed-in company's logo on the map, above GeoNexora's mark (bottom left). A logo uploaded in
 * Admin → Companies is served by our API, which needs the token: it is fetched and shown from memory. An
 * outside address (an old logo URL) is shown as it is.
 */
export const CompanyLogo: React.FC = () => {
  const { user } = useAuth();
  const url = companyLogoUrl(user);
  const src = useLogoSource(url);
  if (!src) return null;
  return (
    <div className="fixed bottom-12 left-3 z-10 px-2 py-1 rounded-lg bg-gn-glass backdrop-blur-sm shadow-md pointer-events-none select-none">
      <img src={src} alt="" className="block max-h-10 max-w-[160px] object-contain" />
    </div>
  );
};

/** An address an <img> can show: our API's through the token, an outside one as it is. */
export function useLogoSource(url: string | null): string | null {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    setSrc(null);
    if (!url) return;
    if (url.startsWith('/api/')) {
      apiClient
        .get(url.substring('/api'.length), { responseType: 'blob' })
        .then((r) => {
          if (cancelled) return;
          objectUrl = URL.createObjectURL(r.data as Blob);
          setSrc(objectUrl);
        })
        .catch(() => setSrc(null));
    } else if (/^https?:\/\//i.test(url) || url.startsWith('data:image/')) {
      setSrc(url);
    }
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);
  return src;
}

export default CompanyLogo;
